import React from 'react';

const Footer = () => {
  return (
    <footer 
      className="bg-gray-900 text-white py-12 bg-cover bg-center bg-fixed relative"
      style={{ 
        backgroundImage: 'url(/images/companyheader.png)',
        backgroundAttachment: 'fixed',
        backgroundSize: 'cover',
        backgroundPosition: 'center'
      }}
    >
      {/* Overlay for better readability */}
      <div className="absolute inset-0 bg-black/60"></div>
      
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
          {/* Left: Logo and Company Name */}
          <div className="flex items-center space-x-3">
            <img 
              src="/images/companylogo.png" 
              alt="WALIC Logo" 
              className="h-10 w-auto"
              onError={(e) => {
                e.target.style.display = 'none';
                console.log('Logo failed to load');
              }}
            />
            <span className="font-semibold text-lg">WALIC Beverage Distributor</span>
          </div>
          
          {/* Center: Copyright */}
          <div className="text-center">
            <p className="text-gray-400 text-sm">
              © 2025 All Rights Reserved
            </p>
          </div>
          
          {/* Right: Powered by */}
          <div className="flex items-center space-x-2">
            <span className="text-gray-400 text-sm">Powered by</span>
            <span className="font-semibold text-blue-400">WALIC Beverage</span>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;